import styles from './PreFooter.module.scss';
import {Col, Container, Row} from "react-bootstrap";
import React from "react";

const PreFooter = () => {

    return (
        <section className={styles.section}>
            <div className={styles.inSection}>
                <Row className={styles.orgLabel}>
                    <Col sm={4}>
                        ИП Селезнев Д. С.
                        <br/>
                        ОГРНИП: 323595800098643
                        <br/>
                        Информация на сайте носит исключительно ознакомительный характер
                    </Col>
                </Row>
                <Row className={styles.altOrgLabel}>
                    <Col sm={9}>
                        ЗООДОКТОР — ветеринарная клиника
                    </Col>
                    <Col sm={3}>
                        <Container className={styles.callBlock}>
                            <p className={styles.telLabel}>
                                8 (902) 477 72-52
                            </p>

                            <p className={styles.descLabel}>
                                Не ответили? Вам перезвонят
                            </p>
                        </Container>
                    </Col>
                </Row>
            </div>
        </section>
    );
};

export default PreFooter;